import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import { Link } from "react-router-dom";
import { FaLaptopCode, FaShoppingCart, FaBuilding, FaCloud, FaDatabase, FaCogs, FaRocket, FaLock } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const services = [
    { icon: FaLaptopCode, title: "1. Discovery & Requirements", description: "We start by understanding your vision, business goals, and technical requirements." },
    { icon: FaBuilding, title: "2. Strategy & Planning", description: "We define the roadmap, selecting the right tech stack and architecture for scalability." },
    { icon: FaCogs, title: "3. UI/UX Design", description: "Our designers create intuitive, user-centric prototypes to validate the experience before coding." },
    { icon: FaCloud, title: "4. Agile Development", description: "We build your platform in iterative sprints, ensuring transparency and continuous feedback." },
    { icon: FaDatabase, title: "5. Quality Assurance", description: "Rigorous testing protocols ensure your application is bug-free, secure, and performant." },
    { icon: FaRocket, title: "6. Deployment & Launch", description: "We manage a smooth go-live process, configuring cloud infrastructure for optimal uptime." },
    { icon: FaShoppingCart, title: "7. Maintenance & Growth", description: "Post-launch support and feature enhancements to keep your platform competitive." },
];

const WebApplicationDevelopment = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % services.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>Web Application Development - Syrol Tech</title>
                <meta name="description" content="Custom web platforms and enterprise systems built with modern technologies, optimized for performance, security, and long-term maintainability." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="Web Application Development"
                pageName="Web Application Development"
                breadcrumbsImg={bannerbg}
            />

            {/* Hero with Banner Image and Brand Color Overlay */}
            <section style={{
                backgroundImage: `url(${bannerbg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '120px 0',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(32, 32, 32, 0.88)',
                    zIndex: 1
                }}></div>

                <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row align-items-center">
                        <div className="col-lg-10 mx-auto text-center">
                            <div style={{ animation: 'fadeIn 1s ease-out' }}>
                                <span style={{
                                    display: 'inline-block',
                                    padding: '8px 20px',
                                    background: '#ffc107',
                                    borderRadius: '30px',
                                    color: '#202020',
                                    fontSize: '0.9rem',
                                    fontWeight: 700,
                                    marginBottom: '20px'
                                }}>
                                    WEB DEVELOPMENT
                                </span>
                                <h1 style={{
                                    color: '#fff',
                                    fontWeight: 800,
                                    fontSize: '3.5rem',
                                    marginBottom: '25px',
                                    lineHeight: 1.2
                                }}>
                                    Build Powerful Web Platforms
                                </h1>
                                <p style={{
                                    color: 'rgba(255,255,255,0.9)',
                                    fontSize: '1.2rem',
                                    marginBottom: '35px',
                                    lineHeight: 1.7,
                                    maxWidth: '800px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}>
                                    Modern, scalable web platforms optimized for performance and security.
                                </p>
                                <Link to="/share-idea" style={{
                                    display: 'inline-block',
                                    padding: '16px 40px',
                                    background: '#ffc107',
                                    color: '#202020',
                                    borderRadius: '8px',
                                    fontWeight: 700,
                                    fontSize: '1rem',
                                    textDecoration: 'none',
                                    boxShadow: '0 10px 30px rgba(255, 193, 7, 0.4)',
                                    transition: 'all 0.3s ease'
                                }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'scale(1.05)';
                                        e.target.style.boxShadow = '0 15px 40px rgba(255, 193, 7, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'scale(1)';
                                        e.target.style.boxShadow = '0 10px 30px rgba(255, 193, 7, 0.4)';
                                    }}>
                                    Start Your Project
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Timeline Style Services */}
            <section style={{ padding: '100px 0', background: '#fff' }}>
                <div className="container">
                    <div className="text-center" style={{ marginBottom: '80px' }}>
                        <h2 style={{
                            fontSize: '2.8rem',
                            fontWeight: 800,
                            color: '#202020',
                            marginBottom: '15px'
                        }}>
                            Our Proven Development Process
                        </h2>
                        <div style={{ width: '80px', height: '4px', background: '#ffc107', margin: '0 auto 15px' }}></div>
                        <p style={{ color: '#505050', fontSize: '1.1rem', maxWidth: '700px', margin: '0 auto' }}>
                            From concept to code, we follow a structured journey to bring your vision to life.
                        </p>
                    </div>

                    <div className="row">
                        {services.map((service, index) => {
                            const Icon = service.icon;

                            return (
                                <div key={index} className="col-lg-10 mx-auto position-relative" style={{ marginBottom: '50px' }}>
                                    {/* Connector Line */}
                                    {index !== services.length - 1 && (
                                        <div style={{
                                            position: 'absolute',
                                            left: '89px', // Aligned with the center of the icon (40px padding + 50px icon center - 1px line width).
                                            top: '100%',
                                            height: '50px',
                                            width: '2px',
                                            background: '#e9ecef',
                                            zIndex: 0,
                                        }} className="d-none d-lg-block"></div>
                                    )}

                                    <div style={{
                                        background: '#fff',
                                        padding: '40px',
                                        borderRadius: '20px',
                                        transition: 'all 0.4s ease',
                                        border: '1px solid #f0f0f0',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '30px',
                                        boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                                        position: 'relative',
                                        zIndex: 1
                                    }}
                                        className="process-card"
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-10px)';
                                            e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                            e.currentTarget.style.borderColor = '#ffc107';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.05)';
                                            e.currentTarget.style.borderColor = '#f0f0f0';
                                        }}
                                    >
                                        <div style={{
                                            flexShrink: 0,
                                            width: '100px',
                                            height: '100px',
                                            background: '#f8f9fa',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: '2px solid #ffc107',
                                            fontSize: '24px',
                                            fontWeight: 'bold',
                                            color: '#202020'
                                        }}>
                                            <Icon style={{ fontSize: '40px', color: '#ffc107' }} />
                                        </div>

                                        <div>
                                            <h4 style={{ color: '#202020', fontWeight: 800, marginBottom: '10px', fontSize: '1.5rem', marginTop: '15px' }}>
                                                {service.title}
                                            </h4>
                                            <p style={{ color: '#54647b', margin: 0, lineHeight: 1.7, fontSize: '1.1rem' }}>
                                                {service.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>


            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />

            <style>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 0.15;
          }
          50% {
            opacity: 0.25;
          }
        }

        @media (max-width: 991px) {
          h1 {
            font-size: 2.5rem !important;
          }
        }

        @media (max-width: 767px) {
          h1 {
            font-size: 2rem !important;
          }
        }
      `}</style>
        </React.Fragment >
    );
};

export default WebApplicationDevelopment;
